
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 54 48","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54 36c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-13.388 6.354l8.903-8.903a.774.774 0 000-1.095L48.42 31.26a.774.774 0 00-1.095 0l-7.26 7.26-3.39-3.39a.774.774 0 00-1.095 0l-1.095 1.096a.774.774 0 000 1.095l5.032 5.032a.774.774 0 001.095 0z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35.25 21h2.25c.555 0 1.086.1 1.577.285C32.191 22.645 27 28.715 27 36c0 4.907 2.356 9.263 5.999 12H4.5A4.501 4.501 0 010 43.5v-18C0 23.016 2.016 21 4.5 21h2.25v-6.75C6.75 6.394 13.144 0 21 0s14.25 6.394 14.25 14.25V21zm-21-6.75V21h13.5v-6.75A6.758 6.758 0 0021 7.5a6.758 6.758 0 00-6.75 6.75z","fill":"currentColor"}})])
          )
        }
      }
    